import {loadLibrary} from "./Util";
import {LIB_URL} from '../App';

if ($('.lazyload').length) {
    loadLibrary(LIB_URL.LAZYSIZES, () => {
        lazySizes.init();
    });
}
